import React, { Component } from 'react'

import './Navigation.css'

class BookingFormNavigation extends Component {

  render() {
    const { fields, activeStep } = this.props

    return (
      <div className="booking-form-nav">
        { fields.map((field, index) => (
          <div key={field.id}
               className={`nav-item ${ index <= activeStep ? 'active' : '' }`}
               style={ { width: `${100 / fields.length}%` } }>
          </div>
        )) }
      </div>
    );
  }
}

export default BookingFormNavigation
